import * as React from "react";
import { useCallback } from "react";
import { TableCell } from "@mzc-pdc/ui";
import { Grid } from "@mui/material";
import Skeleton from "@components_v2/skeleton/skeleton";

export const SelectCollectionsSkeleton = ({ columns, isDisabledCheckbox = false }) => {
    const getSkeletonByColumn = useCallback(
        (column) => {
            const { id, style } = column;

            if (!id) return;
            if (id === "name")
                return (
                    <Grid
                        container
                        direction={`row`}
                        justifyContent={`flex-start`}
                        alignItems={`center`}
                        flexWrap={"nowrap"}
                    >
                        <Grid item>
                            <Skeleton
                                variant="rectangular"
                                animation={"wave"}
                                width={52}
                                height={52}
                                style={{ marginLeft: `6px`, marginRight: `16px` }}
                            />
                        </Grid>
                        <Grid item>
                            <Grid container flexDirection={`column`}>
                                <Grid item>
                                    <Skeleton variant="rectangular" animation={"wave"} width={140} height={21} />
                                </Grid>
                                {/*<Grid item>*/}
                                {/*    <Skeleton*/}
                                {/*        variant="rectangular"*/}
                                {/*        animation={"wave"}*/}
                                {/*        width={170}*/}
                                {/*        height={19}*/}
                                {/*        style={{ marginTop: `8px` }}*/}
                                {/*    />*/}
                                {/*</Grid>*/}
                            </Grid>
                        </Grid>
                    </Grid>
                );
            if (id === "type") return <Skeleton variant="rectangular" animation={"wave"} width={170} height={18} />;
            if (id === "count") return <Skeleton variant="rectangular" animation={"wave"} width={70} height={18} />;
            if (id === "size")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rectangular" animation={"wave"} width={170} height={18} />
                        </Grid>
                    </Grid>
                );
            if (id === "jobId")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rectangular" animation={"wave"} width={170} height={18} />
                        </Grid>
                    </Grid>
                );
            if (id === "access")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rectangular" animation={"wave"} width={110} height={18} />
                        </Grid>
                    </Grid>
                );
            if (id === "owner")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rectangular" animation={"wave"} width={180} height={18} />
                        </Grid>
                    </Grid>
                );
            if (id === "createdAt")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rectangular" animation={"wave"} width={180} height={18} />
                        </Grid>
                    </Grid>
                );
            if (id === "updatedAt")
                return (
                    <Grid container direction={`column`} justifyContent={`flex-start`} alignItems={`center`}>
                        <Grid item>
                            <Skeleton variant="rectangular" animation={"wave"} width={180} height={18} />
                        </Grid>
                    </Grid>
                );
            return null;
        },
        [columns],
    );

    return (
        <>
            {!isDisabledCheckbox && (
                <TableCell style={{ paddingRight: "0px", width: "16px" }} padding="checkbox"></TableCell>
            )}
            {columns &&
                columns.map((column) => (
                    <TableCell
                        key={column.id}
                        style={{
                            ...column.style?.custom,
                            paddingLeft: column.id === "name" ? "0px" : undefined,
                        }}
                    >
                        {getSkeletonByColumn(column)}
                    </TableCell>
                ))}
        </>
    );
};

export default SelectCollectionsSkeleton;
